import React from "react";
import styles from "./AddApplication.module.scss";
import addApp from "../../../assets/images/add-app.png";
import { Button, Toast } from "../../../components";
import {AXIOS} from "../../../services/api";
import {ImageUpload} from "../../../components/image-upload/ImageUpload";
import {InputField} from "../../../components/input-field/InputField";

function AddApplication({onSubmit, onClose}) {
    const [toastInfo, setToastInfo] = React.useState({ message: null, type: "info" });
    const [icon, setIcon] = React.useState(null);
    const [appName, setAppName] = React.useState("");
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [showSuccess, setShowSuccess] = React.useState(false);
    const [optimisticApp, setOptimisticApp] = React.useState(null);

    async function handleSubmit(e) {
        e.preventDefault();
        if (!appName || !icon) {
            setToastInfo({ message: "Please fill all fields", type: "error" });
            return;
        }
        setIsSubmitting(true);
        setOptimisticApp({ name: appName, icon });
        const formData = new FormData();
        formData.append('name', appName);
        formData.append('icon', icon);
        try {
            const response = await AXIOS.post("/applications", formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            if (response.status === 200) {
                setShowSuccess(true);
                setTimeout(() => {
                    setShowSuccess(false);
                    setOptimisticApp(null);
                    onSubmit(response?.data?.data);
                }, 1200);
            } else {
                setIsSubmitting(false);
                setOptimisticApp(null);
                setToastInfo({ message: response?.data?.message || "Failed to add application.", type: "error" });
            }
        } catch (error) {
            setIsSubmitting(false);
            setOptimisticApp(null);
            setToastInfo({ message: error?.response?.data?.message || error?.message || "Failed to add application.", type: "error" });
        }
    }

    function handleToastClose() {
        setToastInfo({ message: null, type: "info" });
    }

    return (
        <>
            <div className={[
                styles.addApp,
                styles.animatedModal,
                showSuccess ? styles.success : ""
            ].join(" ")}> 
                <div className={styles.actionContainer}>
                    <form onSubmit={handleSubmit} className={styles.formCard}>
                        <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                            <ImageUpload onImageChange={setIcon} />
                        </div>
                        <div>
                            <InputField
                                label="App Name"
                                type="text"
                                id="app-name"
                                className="user-form__input"
                                value={appName}
                                placeholder="Application Name"
                                onChange={(e) => setAppName(e.target.value)}
                            />
                        </div>
                        {optimisticApp && isSubmitting && (
                            <div className={styles.optimisticFeedback}>
                                <span>Creating <b>{optimisticApp.name}</b>...</span>
                            </div>
                        )}
                        <div className={styles.actions}>
                            <Button
                                label="Cancel"
                                variant="primary"
                                onClick={onClose}
                                disabled={isSubmitting}
                            />
                            <Button
                                label={isSubmitting ? "Creating..." : "Create"}
                                variant={"primary"}
                                type="submit"
                                disabled={isSubmitting}
                                spinner={isSubmitting}
                            />
                        </div>
                    </form>
                </div>
                <div className={styles.sideImage}>
                    <h2>Add a new App</h2>
                    <img src={addApp} alt="Add a new App"/>
                </div>
                {showSuccess && (
                    <div className={styles.successCheckmark}>
                        <svg viewBox="0 0 52 52"><circle cx="26" cy="26" r="25" fill="none"/><path fill="none" d="M14 27l7 7 16-16"/></svg>
                        <span>App Created!</span>
                    </div>
                )}
            </div>
            {toastInfo.message && (
                <Toast message={toastInfo.message} type={toastInfo.type} onClose={handleToastClose} />
            )}
        </>
    );
}

export {AddApplication};
